<template>
    <!-- Page Content Wrapper -->
    <div v-if="permissionsArray.includes('manage_ops_calendar')" id="page-content-wrapper" class="admin-content-area ops-calendar">
        <div class="container-fluid xyz">
            <div class="page-header-top-container" style="width: 100% !important;">
                <div class="page-name">{{pageTitle}}</div>
                <!-- <button type="submit" v-on:click.prevent="buttonBack()" class="btn btn-primary waves-effect pull-right">Back</button> -->
            </div>
            <!--page content-->
            <div class="admin-page-content">
                <div class="forms-container add_user_forms_container">
                    <div class="row no-margin">
                        <div class="col-12 col-sm-12 col-md-12 col-lg-12 b-25 calendar-main-section">
                            <div class="nevCalendar">
                                <button id="" class="btn btn-success pull-left" @click="previousMonth" style="margin-left: 5px; padding: 9px 12px;"><i class="fa fa-chevron-left" aria-hidden="true"></i></button>
                                <button id="" class="btn btn-success pull-left" @click="nextMonth" style="margin-left: 5px; padding: 9px 12px;"><i class="fa fa-chevron-right" aria-hidden="true"></i></button>
                            </div>
                            <button id="refresh" class="btn btn-success pull-right" style="margin-left: 5px; padding: 7px 12px;" @click="refreshEvents"><i class="fa fa-refresh" aria-hidden="true"></i></button>
                            <button id="backToCalendar" class="btn btn-success pull-right" style="margin-left: 5px; padding: 7px 12px;"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                            <!-- <button type="button" id="openModel" class="btn btn-info btn-lg" data-toggle="modal" data-target="#myModal" style="display: none;">Open Modal</button> -->
                            <div class="btn btn-success form-group pull-right searchBtn" id="search">
                                <input v-model="searchEvents" type="text" class="form-control searchInput" placeholder="Search">
                                <!--<button type="button" class="form-control form-control-submit">Submit</button>-->
                                <span class="search-label"><i class="fa fa-search"></i></span>
                            </div>  
                            <full-calendar id="HRcalendar" :events="events" :config="config" @event-selected="eventSelected" ref="calendar"></full-calendar>
                            <div class="clearfix"></div>

                            <div id="list" class="list-group">
                                <template v-for="(text, index) in eventList">
                                    <button :key="'display-event ' + index" @click="loadEvent(text.value)" type="button" class="list-group-item list-group-item-action">
                                        {{text.text}}
                                        <span class="pull-right">
                                            {{text.start}}
                                        </span>
                                    </button>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="medium-modal">
                <b-modal ref="my-modal" id="modallg" size="lg" :title="modalTitle" class="modal-section" @hidden="closeModalEvent">
                    <form id="modalForm" enctype="multipart/form-data">
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Type: </div>
                            </div>
                            <div class="">
                                <!-- <v-select v-model="eventTypeId" name="eventTypeId" placeholder="Select Type"
                                    label="text"
                                    class="form-control"
                                    @change="eventTypeChange"
                                    :options="eventTypeArr" :clearable=false>
                                </v-select> -->
                                <select class="form-control" v-model="eventTypeId">
                                    <option v-for="evType in eventTypeArr" :value="evType.value" :key="evType.value">
                                        {{ evType.text }}
                                    </option>
                                </select>
                                <div class="requiredstar">*</div>
                                <p class="text-danger">{{eventTypeIdError}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block" style="clear:both;">
                            <div class="">
                                <div class="form-label">Title: </div>
                            </div>
                            <div class="">
                                <input @input="titleError = ''" class="form-control" id="title" placeholder="Enter Title" v-model="title">
                                <div class="requiredstar">*</div>
                                <p class="text-danger">{{titleError}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Description: </div>
                            </div>
                            <div class="">
                                <textarea rows="5" @input="descriptionError = ''" class="form-control" id="description" v-model="description"></textarea>
                                <div class="requiredstar">*</div>
                                <p class="text-danger">{{descriptionError}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Start Date Time: </div>
                            </div>
                            <div class="">
                                <date-picker
                                    id="startDateTime"
                                    v-model="startDateTime"
                                    :config="configStart"
                                    @dp-change="onStartChange"
                                    class="form-control"
                                    placeholder="Select Start Date Time"
                                    name="startDate"
                                ></date-picker>
                                <div class="requiredstar">*</div>
                                <p class="text-danger">{{startDateTimeError}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">End Date Time: </div>
                            </div>
                            <div class="">
                                <date-picker
                                    id="endDateTime"
                                    v-model="endDateTime"
                                    :config="configEnd"
                                    @dp-change="onEndChange"
                                    class="form-control"
                                    placeholder="Select End Date Time"
                                    name="endDate"
                                ></date-picker>
                                <div class="requiredstar">*</div>
                                <p class="text-danger">{{endDateTimeError}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Created By: </div>
                            </div>
                            <div class="">
                                <p class="form-control">{{loginUsername}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Created At: </div>
                            </div>
                            <div class="">
                                <p class="form-control">{{eventCreatedAt}}</p>
                            </div>
                        </div>
                    </form>
                    <div class="col-md-12 forms-block">
                        <input id="addUpdateOPSCalendarEvent" :disabled="disableButtons.save" type="submit" :value="buttonNames.save" class="btn btn-primary" v-on:click.prevent="addUpdateOPSCalendarEvent()">
                    </div>
                </b-modal>
                <b-modal ref="view-modal" id="modallg" size="lg" title="View OPS Calendar Event" class="modal-section" @hidden="closeViewModalEvent">
                    <form id="modalForm" enctype="multipart/form-data">
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Type: </div>
                            </div>
                            <div class="">
                                <p class="form-control">{{strEventType}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Title: </div>
                            </div>
                            <div class="">
                                <p class="form-control">{{title}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Description: </div>
                            </div>
                            <div class="">
                                <p class="form-control" style="height: auto;">{{description}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Start Date Time: </div>
                            </div>
                            <div class="">
                                <p class="form-control">{{startDateTime}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">End Date Time: </div>
                            </div>
                            <div class="">
                                <p class="form-control">{{endDateTime}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Created By: </div>
                            </div>
                            <div class="">
                                <p class="form-control">{{updatedBy}}</p>
                            </div>
                        </div>
                        <div class="col-md-12 forms-block">
                            <div class="">
                                <div class="form-label">Created At: </div>
                            </div>
                            <div class="">
                                <p class="form-control">{{updatedAt}}</p>
                            </div>
                        </div>
                    </form>
                </b-modal>
            </div>
        </div>
        <app-footer></app-footer>
    </div>
    <div v-else>
        <no-permission></no-permission>
    </div>
</template>

<script>
    var self;
    import Vue from 'vue';
    import vSelect from 'vue-select';
    import Footer from '@/components/partials/Footer';
    import EventBus from '.././event-bus';
    import {commonMixins} from '../../mixins/commonMixins';
    import {HTTP} from '../../http-common.js';
    var moment = require('moment-timezone');
    import { FullCalendar } from 'vue-full-calendar';
    import 'fullcalendar/dist/fullcalendar.css';
    import datePicker from 'vue-bootstrap-datetimepicker';
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
    import NoAccessPermission from './../NoAccessPermission';

    export default {
        name: 'OPSCalendar',
        mixins: [commonMixins],
        components: {
            'app-footer': Footer,
            'v-select': vSelect,
            'full-calendar': FullCalendar,
            datePicker,
            "no-permission" : NoAccessPermission,
        },
        data() {
            return {
                pageTitle: "OPS Calendar",
                modalTitle: "Add OPS Calendar Event",
                startDate: 0,
                endData: 0,
                events: [
                    /* {
                        id: 1,
                        title: 'event1',
                        start: '2021-12-01',
                    },
                    {
                        id: 2,
                        title: 'event2',
                        start: '2021-12-01',
                        start: '2021-12-10',
                    },
                    {
                        id: 3,
                        title: 'event3',
                        start: '2021-12-20T12:30:00',
                        allDay: false,
                    }, */
                ],
                selected: {},
                eventList: [],
                searchEvents: '',
                eventEditId: 0,
                buttonNames : {
                    save : 'Save',
                },
                disableButtons : {
                    save : false,
                },
                title: '',
                titleError: '',
                description: '',
                descriptionError: '',
                /* options: {
                    format: 'MM/DD/YYYY hh:ssA',
                    useCurrent: false,
                    allowInputToggle: true,
                    widgetPositioning: {
                        horizontal: 'auto',
                        vertical: 'bottom'
                    },
                    // disabledTimeIntervals: false,
                }, */
                configStart: {
                    format: 'MM/DD/YYYY hh:ssA',
                    // minDate: new Date(),
                    maxDate: false,
                },
                startDateTime: '',
                startDateTimeError: '',
                configEnd: {
                    format: 'MM/DD/YYYY hh:ssA',
                    minDate: false,
                },
                endDateTime: '',
                endDateTimeError: '',
                strEventType: '',
                updatedBy: '',
                updatedAt: '',
                loginUsername: '',
                eventCreatedAt: '',
                eventTypeId: "",
                eventTypeIdError: "",
                eventTypeArr: [
                    {
                        text: 'LOA',
                        value: 'LOA'
                    },
                    {
                        text: 'Other',
                        value: 'Other'
                    },
                    {
                        text: 'Sick',
                        value: 'Sick'
                    },
                    {
                        text: 'Vacation',
                        value: 'Vacation'
                    },
                ],

                config: {
                    /*'weekends': false,*/
                    defaultDate: moment(new Date()).format("YYYY-MM-DD"),
                    defaultView: 'month',
                    displayEventTime: false,
                    editable: false,
                    eventLimit: true,
                    noEventsMessage: "OPS Calendar Events Not Available",
                    eventClick: (event) => {
                        this.selected = event;
                        // var selectDate = moment(event.start).format("YYYY-MM-DD");
                        var endDate = moment(event.end_date_time).format("YYYY-MM-DD");
                        var currentDate = moment(new Date()).format("YYYY-MM-DD");
                        // console.log(endDate);
                        // if(selectDate < currentDate) {
                        if(endDate < currentDate) {
                            // View Page
                            this.viewModal(event);
                        } else {
                            var userObj = localStorage.getItem("user_obj");
                            if (userObj != null) {
                                var userJson = JSON.parse(userObj);
                                if(userJson['id'] != event.updated_by) {
                                    this.viewModal(event);
                                } else {
                                    this.showModel('edit', event, '', '');
                                }
                            } else {
                                this.showModel('edit', event, '', '');
                            }
                        }
                    },
                    dayClick: (date, jsEvent, view) => {
                        var selectDate = moment(date).format("YYYY-MM-DD");
                        var currentDate = moment(new Date()).format("YYYY-MM-DD");
                        // console.log(selectDate);
                        if(selectDate < currentDate) {
                            return false;
                        } else {
                            // var convertDateTime = moment(date).tz(moment.tz.guess()).format('MM/DD/YYYY hh:ssA');
                            var convertDateTime = moment(date).format('MM/DD/YYYY hh:ssA');
                            this.showModel('add', 0, convertDateTime, date);
                        }
                    },
                    header: {
                        /*left: 'prev,next',*/
                        left: '',
                        center: 'title',
                        right: 'month,listMonth',
                    },
                    buttonText: {
                        /*'prev': 'Previous',
                         'next': 'Next',*/
                        'month': 'Month',
                        'listMonth': 'List',
                    },
                },
                permissionsArray: ['manage_ops_calendar'],
            }
        },
        watch: {
            searchEvents: function (searchEvents) {
                self.searchEvent();
            }
        },
        beforeMount: function () {
            self = this;
            EventBus.$emit("menu-selection-changed", "ops-calendar");
        },
        mounted: function () {
            var userObj = localStorage.getItem("user_obj");
            //if user logged in than remove login button and registration button
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginUsername = userJson.first_name + " " + userJson.last_name;
            }
            self.getUserPermissions();
            self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
            self.endDate = self.$refs.calendar.fireMethod('getView').end.format();

            self.loadOPSCalendarEvents();
            // Hide Initially
            $("#list").hide();
            $("#backToCalendar").hide();

            $("#link").click(function () {
                $('#myModal').modal('toggle');
            });

            $(document).ready(function () {
                $('#search').on("click", (function (e) {
                    $(".searchBtn").addClass("sb-search-open");
                    $("#HRcalendar").hide();
                    $("#refresh").hide();
                    $(".nevCalendar").hide();
                    $("#backToCalendar").show();
                    $("#list").show();
                    e.stopPropagation();
                }));
            });

            $(document).ready(function () {
                $('#backToCalendar').on("click", (function (e) {
                    $(".searchBtn").removeClass("sb-search-open");
                    $("#HRcalendar").show();
                    $("#refresh").show();
                    $(".nevCalendar").show();
                    self.searchEvents = '';
                    $("#backToCalendar").hide();
                    $("#list").hide();
                    e.stopPropagation();
                }));
            });
            $(self.$refs['my-modal']).on("hidden.bs.modal", self.closeModalEvent);
            $(self.$refs['view-modal']).on("hidden.bs.modal", self.closeViewModalEvent);
        },
        methods: {
            eventTypeChange: function() {
                self.eventTypeIdError = '';
            },
            viewModal: function(event) {
                // view-modal
                self.title = event.title;
                self.description = event.description;
                self.startDateTime = event.start_date_time;
                self.endDateTime = event.end_date_time;
                self.updatedBy = event.updated_by_name;
                self.updatedAt = event.updated_at;
                self.strEventType = event.event_type;
                self.$refs['view-modal'].show();
            },
            closeViewModalEvent: function() {
                self.$refs['view-modal'].hide();
            },
            closeModalEvent: function() {
                self.clearModalForm();
            },
            clearModalForm: function() {
                self.title = '';
                self.titleError = '';
                
                self.description = '';
                self.descriptionError = '';

                var startTime = '00:00:00';
                self.startDateTime = moment(moment(new Date()).format('YYYY-MM-DD') + " " + startTime).format('MM/DD/YYYY hh:ssA');
                self.startDateTimeError = "";
                
                var endTime = '23:59:59';
                self.endDateTime = moment(moment(new Date()).format('YYYY-MM-DD') + " " + endTime).format('MM/DD/YYYY hh:ssA');
                self.endDateTimeError = "";
            },
            changeStartDateTime: function () {
                self.startDateTimeError = "";
            },
            onStartChange(selectedDates, dateStr, instance) {
                self.$set(self.configEnd, 'minDate', selectedDates.date);
            },
            changeEndDateTime: function () {
                self.endDateTimeError = "";
            },
            onEndChange(selectedDates, dateStr, instance) {
                self.$set(self.configStart, 'maxDate', selectedDates.date);
            },
            previousMonth() {
                self.$refs.calendar.fireMethod('prev');
                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                self.loadOPSCalendarEvents();
            },
            nextMonth() {
                self.$refs.calendar.fireMethod('next');
                self.startDate = self.$refs.calendar.fireMethod('getView').start.format();
                self.endDate = self.$refs.calendar.fireMethod('getView').end.format();
                self.loadOPSCalendarEvents();
            },
            loadEvent: function(id) {
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    }
                };
                var data = {
                    id: id,
                    tz: moment.tz.guess(),
                };
                HTTP.post("/event/get", data, config)
                    .then(function (response) {
                        self.selected = response.data.content[0];
                        var userObj = localStorage.getItem("user_obj");
                        if (userObj != null) {
                            var userJson = JSON.parse(userObj);
                            if(userJson['id'] != self.selected.updated_by) {
                                self.viewModal(self.selected);
                            } else {
                                var selectDate = moment(self.selected.start_date).format("YYYY-MM-DD");
                                var currentDate = moment(new Date()).format("YYYY-MM-DD");
                                if(selectDate < currentDate) {
                                    self.viewModal(self.selected);
                                } else {
                                    self.showModel('edit', self.selected, '', '');
                                }
                            }
                        } else {
                            var selectDate = moment(self.selected.start_date).format("YYYY-MM-DD");
                            var currentDate = moment(new Date()).format("YYYY-MM-DD");
                            if(selectDate < currentDate) {
                                self.viewModal(self.selected);
                            } else {
                                self.showModel('edit', self.selected, '', '');
                            }
                        }
                    })
                    .catch(function (err) {
                        self.catchHandler(err, function () {});
                    });
            },
            searchEvent: function() {
                if (self.searchEvents.length >= 1) {
                    var config = {
                        headers: {
                            Authorization:localStorage.getItem("access_token")
                        },
                    };
                    var data = {
                        start_date: self.startDate,
                        end_date: self.endDate,
                        search: self.searchEvents,
                        tz: moment.tz.guess(),
                    };
                    HTTP.post("/event/search", data, config)
                        .then(function (response) {
                            self.eventList = response.data.content;
                        })
                        .catch(function (err) {
                            self.catchHandler(err, function () {});
                        });
                }
            },
            refreshEvents() {
                self.loadOPSCalendarEvents();
            },
            showModel: function(mode, eventObject, selectedModalStatrDateTime, selectedModalEndDateTime) {
                // $('#openModel').click();
                if(mode == 'edit') {
                    self.eventEditId = eventObject.id;
                    self.modalTitle = "Update OPS Calendar Event";
                    self.buttonNames.save = 'Update';
                    self.title = eventObject.title;
                    self.description = eventObject.description;
                    self.startDateTime = eventObject.start_date_time;
                    self.endDateTime = eventObject.end_date_time;
                    self.loginUsername = eventObject.updated_by_name;
                    self.eventCreatedAt = eventObject.updated_at;
                    // self.eventTypeId = {text: eventObject.event_type, value: eventObject.event_type};
                    self.eventTypeId = eventObject.event_type;
                } else {
                    self.eventEditId = 0;
                    self.modalTitle = "Add OPS Calendar Event";
                    self.buttonNames.save = 'Save';

                    var endTime = '23:59:59';
                    self.startDateTime = selectedModalStatrDateTime;
                    var tempDate = moment(moment(selectedModalEndDateTime).format('YYYY-MM-DD') + " " + endTime).format('MM/DD/YYYY hh:ssA');
                    self.endDateTime = tempDate;
                    self.eventCreatedAt = moment(new Date()).format("MM/DD/YYYY hh:ssA");
                }
                self.$refs['my-modal'].show();
            },
            eventSelected: function(event) {
                self.selected = event;
            },
            loadOPSCalendarEvents: function() {
                self.$refs['my-modal'].hide();
                self.selected = {};
                var fields = {
                    start_date: self.startDate,
                    end_date: self.endDate,
                    tz: moment.tz.guess(),
                };
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                };
                self.showLoader();
                HTTP.post('/ops/calendar/events/get', fields, config)
                    .then(response => {
                        self.hideLoader();
                        self.events = response.data.content;
                        self.$refs.calendar.$emit('refetch-events');
                    })
                    .catch(function (err) {
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            checkForm: function() {
                var checked = true;
                self.titleError = '';
                self.descriptionError = '';
                self.startDateTimeError = '';
                self.endDateTimeError = '';
                self.eventTypeIdError = '';

                if(!self.eventTypeId) {
                    self.eventTypeIdError = "Select Type";
                    if (checked) {
                        checked = false;
                    }  
                }
                if (!self.title) {
                    self.titleError = "Title Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.description) {
                    self.descriptionError = "Description Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.startDateTime) {
                    self.startDateTimeError = "Please select Start Date Time";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.endDateTime) {
                    self.endDateTimeError = "Please select End Date Time";
                    if (checked) {
                        checked = false;
                    }
                }
                if(self.startDateTime && self.endDateTime) {
                    var tempStratDateTime = new Date(self.startDateTime);
                    var tempEndDateTime = new Date(self.endDateTime);
                    if(tempEndDateTime < tempStratDateTime) {
                        self.endDateTimeError = "Select Valid End Date Time";
                        if (checked) {
                            checked = false;
                        }
                    }
                }
                return checked;
            },
            addUpdateOPSCalendarEvent: function() {
                setTimeout(() => {
                    if(self.checkForm()) {
                        var fields = {
                            id: self.eventEditId,
                            event_type_id: self.eventTypeId,
                            title: self.title,
                            description: self.description,
                            start_date_time: self.startDateTime,
                            end_date_time: self.endDateTime,
                            tz: moment.tz.guess(),
                        };
                        var config = {
                            headers: {
                                Authorization:localStorage.getItem("access_token")
                            },
                        };
                        HTTP.post('/event/add/update', fields, config)
                            .then(response => {
                                self.showSAlert(response.data.message, 'success')
                                self.clearModalForm();
                                self.loadOPSCalendarEvents();
                            })
                            .catch(function (err) {
                                self.catchHandler(err, function () {});
                            });
                    }
                }, 200);
            },
        }
    }
    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            for (var i = 0; i < permissionArray.length; i++) {
                self.permissionsArray.push(permissionArray[i].name);
            }
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/OPSCalendarMaster/OPSCalendar.vue